export const comments_5618937 = {"data":{"data":[],"links":{}}}